import { NgModule } from '@angular/core';
import { DefaultContentComponent } from './default-content.component';


@NgModule({
  declarations: [
    DefaultContentComponent
  ],
  exports: [
    DefaultContentComponent
  ]
})
export class DefaultContentModule {
}
